import configFile from '../config.json';
import {IFdApplicationType} from 'constants/interfaces';
const moment = require('moment');

const config: any = configFile;
const environment: any = process.env.REACT_APP_ENV ?? 'development';
export const IMAGE_API_ROOT = config[environment].imageApiRoot;
export const GRAPH_API = config[environment].graphApi;
export const NODE_API = config[environment].nodeApi;
export const FILE_API = config[environment].fileApi;
export const FARMER_SITE_URL = config[environment].farmerSiteUrl;
export const ANALYTICS_API = config[environment].analyticsApi;
export const GOOGLE_API_KEY = 'AIzaSyAqjBK8fP6gSGZS9oocUYv-bDM-b88cOoo';
export const FIREBASE_CONFIG = config[environment].firebaseConfig;
export const PLATFORM_ID = 'WEB_SUPPLIER';
export const SOCKET_URL = config[environment].socketUrl;
export const _GetImagePath = (name: string) =>
  name ? `${IMAGE_API_ROOT}${name.replace(/ /g, '').toLowerCase()}.png` : '';
export const _GetCategoryImagePath = (name: string) =>
  `https://khula-farmer-profiles.s3.us-east-2.amazonaws.com/products-images/${
    name
      ? name.toLocaleLowerCase().replace(/ /g, '').trim() === 'saad'
        ? 'seedtreatment'
        : name.toLocaleLowerCase().replace(/ /g, '').trim()
      : ''
  }.png`;
export const _NumberWithSpaces = (x: any) =>
  (typeof x === 'number' ? x.toFixed(2) : x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
export const _ToTitleCase = (phrase: string) =>
  phrase
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
export const _CleanCategoriesStringArray = (name: any) =>
  _ToTitleCase(name.toString().toLocaleLowerCase().replace(/,/g, ', '));
export const _GetSoilPath = () =>
  'https://khula-farmer-profiles.s3.us-east-2.amazonaws.com/products-images/soil.png';
export const _GetDefaultProfileImage = () =>
  'https://khula-farmer-profiles.s3.amazonaws.com/produceImages/1586127697179_.png';

export const _IsLink = (url: string) => {
  const regexp =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!]))?/;
  return regexp.test(url);
};

export function _TotalFundingAsk(application?: IFdApplicationType) {
  if (!application?.fundingAsk?.fundingRequestCosts) return 'R TBD';
  const totalFundingAsk = application.fundingAsk.fundingRequestCosts.reduce(
    (acc, val) => acc + val.cost,
    0,
  );
  return 'R' + _NumberWithSpaces(totalFundingAsk);
}

export enum ESidePanelView {
  INVOICE = 'invoice',
  ADD_TEAM_MEMBER = 'add_team_member',
  EDIT_TEAM_MEMBER = 'edit_team_member',
  REMOVE_TEAM_MEMBER = 'remove_team_member',
  EDIT_TEAM_MEMBER_PERMISSIONS = 'edit_team_member_permissions',
  CREATE_QUOTE = 'add_quote',
  ADD_CUSTOMER = 'add_customer',
  ADD_DEPOT = 'add_depot',
  EDIT_DEPOT = 'edit_depot',
  ADD_PRODUCT = 'add_product',
  EDIT_PRODUCT = 'edit_product',
  COPY_PRODUCT = 'copy_product',
  PROMOTE_PRODUCT = 'promote_product',
  EDIT_INVENTORY = 'edit_inventory',
  ADD_PROGRAM = 'add_program',
  ADD_PROGRAM_LINE = 'add_program_line',
  EDIT_PROGRAM_LINE = 'edit_program_line',
  COPY_PROGRAM_LINE = 'copy_program_line',
  // New entry for soil data
  ADD_SOIL_DATA = 'add_soil_data',
  ADD_CUSTOMER_CONTRACT = 'add_customer_contract',
  ADD_FD_USER = 'add_fd_user',
  EDIT_FD_USER = 'edit_fd_user',
  ADD_FD_FARM = 'add_fd_farm',
  EDIT_FD_FARM = 'edit_fd_farm',
  ADD_FD_COMPANY = 'add_fd_company',
  EDIT_FD_COMPANY = 'edit_fd_company',
  EDIT_FD_PRODUCTION_PLANS = 'edit_fd_production_plans',
  EDIT_FD_PRODUCTION_PLAN = 'edit_fd_production_plan',
  EDIT_FD_PRODUCTION_HISTORY = 'edit_fd_production_history',
  EDIT_FD_FINANCIAL_HISTORY = 'edit_fd_financial_history',
  EDIT_FD_OPERATING_COSTS = 'edit_fd_operating_costs',
  EDIT_FD_OPERATING_COST = 'edit_fd_operating_cost',
  EDIT_FD_ASSETS = 'edit_fd_assets',
  EDIT_FD_ASSET = 'edit_fd_asset',
  EDIT_FD_LIABILITIES = 'edit_fd_liabilities',
  EDIT_FD_LIABILITY = 'edit_fd_liability',
  EDIT_FD_PRODUCTION_COST = 'edit_fd_production_cost',
  EDIT_FD_FARM_TEAM = 'edit_fd_farm_team',
  EDIT_FD_CUSTOMERS = 'edit_fd_customers',
  EDIT_FD_SUPPLIERS = 'edit_fd_suppliers',
  EDIT_FD_RISKS = 'edit_fd_risks',
  EDIT_FD_FUNDING_ASK = 'EDIT_FD_FUNDING_ASK',
  CUSTOMISE_OVERVIEW = 'CUSTOMISE_OVERVIEW',
  ADD_WALLET_RESTRICTION = 'ADD_WALLET_RESTRICTION',
  EDIT_WALLET_RESTRICTION = 'EDIT_WALLET_RESTRICTION',
}

export enum ESupplierUserPermissions {
  'COMPANY_READ' = 'COMPANY_READ',
  'COMPANY_WRITE' = 'COMPANY_WRITE',
  'COMPANY_ONBOARD' = 'COMPANY_ONBOARD',

  'TEAM_READ' = 'TEAM_READ',
  'TEAM_WRITE' = 'TEAM_WRITE',

  'DEPOT_READ' = 'DEPOT_READ',
  'DEPOT_WRITE' = 'DEPOT_WRITE',

  'CUSTOMER_READ' = 'CUSTOMER_READ',
  'CUSTOMER_WRITE' = 'CUSTOMER_WRITE',
  'CUSTOMER_ADD' = 'CUSTOMER_ADD',

  'CUSTOMER_CHAT_READ' = 'CUSTOMER_CHAT_READ',
  'CUSTOMER_CHAT_WRITE' = 'CUSTOMER_CHAT_WRITE',

  'PRODUCT_READ' = 'PRODUCT_READ',
  'PRODUCT_WRITE' = 'PRODUCT_WRITE',
  'PRODUCT_PROMOTE' = 'PRODUCT_PROMOTE',

  'DEPOT_PRODUCT_READ' = 'DEPOT_PRODUCT_READ',
  'DEPOT_PRODUCT_WRITE' = 'DEPOT_PRODUCT_WRITE',

  'QUOTE_READ' = 'QUOTE_READ',
  'QUOTE_WRITE' = 'QUOTE_WRITE',
  'QUOTE_MANAGE_DOCUMENTS' = 'QUOTE_MANAGE_DOCUMENTS',

  'QUOTE_CHAT_READ' = 'QUOTE_CHAT_READ',
  'QUOTE_CHAT_WRITE' = 'QUOTE_CHAT_WRITE',

  'ORDER_READ' = 'ORDER_READ',
  'ORDER_WRITE' = 'ORDER_WRITE',
  'ORDER_MANAGE_DOCUMENTS' = 'ORDER_MANAGE_DOCUMENTS',
  'ORDER_MANAGE_PAYMENTS' = 'ORDER_MANAGE_PAYMENTS',

  'ORDER_CHAT_READ' = 'ORDER_CHAT_READ',
  'ORDER_CHAT_WRITE' = 'ORDER_CHAT_WRITE',

  'GROUP_READ' = 'GROUP_READ',
  'GROUP_WRITE' = 'GROUP_WRITE',
}

/** Order/Invoice detail view state: proforma (order) vs converted invoice */
export enum EOrderState {
  PROFORMA = 'PROFORMA',
  INVOICE = 'INVOICE',
}

export enum ESupplierUserPermissionIds {
  'COMPANY_READ' = 1,
  'COMPANY_WRITE',
  'COMPANY_ONBOARD',

  'TEAM_READ',
  'TEAM_WRITE',

  'DEPOT_READ',
  'DEPOT_WRITE',

  'CUSTOMER_READ',
  'CUSTOMER_WRITE',
  'CUSTOMER_ADD',

  'CUSTOMER_CHAT_READ',
  'CUSTOMER_CHAT_WRITE',

  'PRODUCT_READ',
  'PRODUCT_WRITE',
  'PRODUCT_PROMOTE',

  'DEPOT_PRODUCT_READ',
  'DEPOT_PRODUCT_WRITE',

  'QUOTE_READ',
  'QUOTE_WRITE',
  'QUOTE_MANAGE_DOCUMENTS',

  'QUOTE_CHAT_READ',
  'QUOTE_CHAT_WRITE',

  'ORDER_READ',
  'ORDER_WRITE',
  'ORDER_MANAGE_DOCUMENTS',
  'ORDER_MANAGE_PAYMENTS',

  'ORDER_CHAT_READ',
  'ORDER_CHAT_WRITE',
}

export enum IlogisticsTypeId {
  COLLECTION = 1,
  FREE_DELIVERY = 2,
  COURIER_GUY_DELIVERY = 3,
  SUPPLIER_CUSTOM = 4,
}

export enum EInputOrderPaymentType {
  INVOICE = 1,
  WALLET = 4,
}

export const VAT = 0.15;

export enum IPurchaseOrderStatus {
  'Unconfirmed' = 1,
  'StockConfirmed' = 2,
  'NoStock' = 3,
  'StockUpdatesRequested' = 4,
  'PoCreated' = 5,
  'CourierCollectionArranged' = 6,
  'Delivered' = 7,
  'Invoiced' = 8,
  'Paid' = 9,
}

export enum EPurchaseOrderSupportingDocs {
  'Waybill' = 'Waybill',
  'DeliveryNote' = 'Delivery Note',
  'Invoice' = 'Invoice',
}

export const formatDate = (date: string, format?: string): string => {
  return format
    ? moment.utc(date).format(format)
    : moment.utc(date).format('YYYY-MM-DD hh:mm:ss');
};

export const PROGRAM_TYPES = ['Seed', 'Fertilizer', 'Chemical'];
export const PROGRAM_STAGES = [
  'Planting',
  'Pre-emergence',
  'Post-emergence',
  'Pre-planting',
  'Top Dressing',
  'Week 1',
  'Week 2',
  'Week 3',
  'Week 4',
  'Week 5',
  'Week 6',
  'Week 7',
  'Week 8',
  'Week 9',
  'Week 10',
  'Week 11',
  'Week 12',
  'Week 13',
  'Week 14',
  'Week 15',
  'Week 16',
  'Week 17',
  'Week 18',
  'Week 19',
  'Week 20',
  'Burn-down',
  'V4-V6',
  'V8-V12',
  'R1-R2',
  'Seed Dressing',
  'End of Pot Set',
];
export const PROGRAM_APPLICATION_UNIT = [
  'ml',
  'l',
  'seeds',
  'bags',
  'kgs',
  'grams',
];
export const PROGRAM_APPLICATION_TYPE = [
  'Per Hectare',
  'Per Tree',
  'Per 100 liters',
  'Per 1T seed',
];

export enum EFarmArrangement {
  LEASED = 'LEASED',
  OWNED = 'OWNED',
  BOTH = 'BOTH',
  NOT_YET_ADDED = 'NOT_YET_ADDED',
}

export enum EAssetCondition {
  NEW = 'NEW',
  LIKE_NEW = 'LIKE_NEW',
  GOOD = 'GOOD',
  FAIR = 'FAIR',
  POOR = 'POOR',
}

export enum EAssetType {
  ASSET = 'ASSET',
  CAPEX = 'CAPEX',
}

export enum EApplicationStateType {
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING_REVIEW = 'PENDING_REVIEW',
  IN_REVIEW = 'IN_REVIEW',
  SUBMITTED_TO_CREDIT = 'SUBMITTED_TO_CREDIT',
  DECLINED = 'DECLINED',
  PENDING_SIGNATURES = 'PENDING_SIGNATURES',
  PENDING_PAYOUT = 'PENDING_PAYOUT',
  FINAL_STAGE = 'FINAL_STAGE',
  CONDITION_PRECEDENT = 'CONDITION_PRECEDENT',
  TERM_SHEET_SIGNATURE = 'TERM_SHEET_SIGNATURE',
}

export enum EIrrigation {
  DRYLAND = 'DRYLAND',
  IRRIGATED = 'IRRIGATED',
  BOTH = 'BOTH',
}

export enum ETraderTradeType {
  SUPPLIER = 'SUPPLIER',
  BUYER = 'BUYER',
}

export enum EDocType {
  CIPC = 'CIPC',
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  BANK_STATEMENT = 'BANK_STATEMENT',
  PROOF_OF_BANKING = 'PROOF_OF_BANKING',
  BANK_COMFIRMATIVE_LETTER = 'BANK_COMFIRMATIVE_LETTER',
  BBBEE_CERTIFICATE = 'BBBEE_CERTIFICATE',
  AFS1 = 'AFS1',
  AFS2 = 'AFS2',
  AFS3 = 'AFS3',
  TITLE_DEED = 'TITLE_DEED',
  DIRECTORS_ID = 'DIRECTORS_ID',
  LEASE_AGREEMENT = 'LEASE_AGREEMENT',
  WATER_RIGHT = 'WATER_RIGHT',
  SARS_TAX_PIN = 'SARS_TAX_PIN',
  SUPPLIER_MOU = 'SUPPLIER_MOU',
  CONSENT_FORM = 'CONSENT_FORM',
  APPLICANTS_ID = 'APPLICANTS_ID',
  OTHER = 'OTHER',
  VAT_CERTIFICATE = 'VAT_CERTIFICATE',
  MARRIAGE_CERTIFICATE = 'MARRIAGE_CERTIFICATE',
  AFFIDAVIT = 'AFFIDAVIT',
}
